module.exports = {"websocket":"","address_prefix":"VIZ","chain_id":"2040effda178d4fffff5eab7a915d4019879f5205cc5392e4bcced2b6edda0cd","broadcast_transaction_with_callback":false}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 166
// module chunks = 0 1